module.exports = "<div>\n  <app-new-page [pageTitle]=\"page.title\" [pageSlug]=\"page.slug\"></app-new-page>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/activities/activities.component.html
// module id = ../../../../../src/app/event/activities/activities.component.html
// module chunks = main